import axios from "axios";

export async function OnLogin() {
    await axios.post("api/Roles/onlogin")
        .catch((err) => {
            console.log(err);
        });
}

export async function fetchConfigurationSettings() {
    const response = await fetch("api/configuration");
    return await response.json();
}

export async function getOrganization(organizationId, tenantAccountId = 0) {
    const response = await axios
        .get(`api/Tenant/${tenantAccountId ? tenantAccountId : organizationId}/Organizations/${organizationId}`)
        .catch((err) => {
            return err.response.status;
        });
    return response;
}
export async function getSubOrganizations(organizationId) {
    const response = await axios
        .get(`api/Organization/${organizationId}/SubOrganizations`)
        .catch((err) => {
            return err.response;
        });
    return response;
}
export async function getLocations(organizationId) {
    const response = await axios
        .get(`api/Organization/${organizationId}/Locations`)
        .catch((err) => {
            return err.response;
        });
    return response;
}
export async function getFullSubOrganizations(organizationId) {
    const response = await axios
        .get(`api/Organization/${organizationId}/SubOrganizationsFull`)
        .catch((err) => {
            return err.response;
        });
    return response;
}
export async function createSubOrganization(organizationId, model) {

    try {
        const response = await axios
            .post(`api/Organization/${organizationId}/SubOrganizations`, model)
            .catch((err) => {
                return err.response;
            });
        return response;
    }
    catch (error) {
        console.log(error);
    }
    
}
export async function updateOrganization(tenantAccountId, organizationId, model) {
    const response = await axios
        .put(`api/Organization/${tenantAccountId}/${organizationId}`, model)
        .catch((err) => {
            return err.response;
        });
    return response;
}

export async function deleteOrganization(organizationId) {
    const response = await axios
        .delete(`api/Organization/Delete/${organizationId}`)
        .catch((err) => {
            return err.response;
        });
    return response;
}

export async function deleteDevice(orgId, deviceId) {
    const response = await axios
        .delete(`api/Device/Delete/${orgId}/${deviceId}`)
        .then(res => {
            if (res.status === 204)
                return res;

        })
        .catch((err) => {
            return err.response;
        });

    return response;
}

export async function assignUnassignLicense(deviceId, action, subscriptionId) {
    const response = await axios
        .put(`api/Device/AssignUnassignLicense/${deviceId}/${subscriptionId}?action=${action}`)
        .catch((err) => {
            return { errorMsg: err.response.data };
        });
    return response;
} 

export async function updateDevice(orgId, device) {
    const response = await axios
        .put(`api/Device/Update/${orgId}`, device)
        .catch((err) => {
            return err.response.status;
        });

    return response;
}

export async function createDevice(locationId, device, subscriptionId, orgId) {
    const response = await axios
        .post(`api/Device/Create/${locationId}?subscriptionId=${subscriptionId}&orgId=${orgId}`, device)
        .catch((err) => {
            return {
                status: err.response.status,
                errorMsg: err.response.data
            };
        });

    return response;
}

export async function getDevices(orgId) {
    const response = await axios
        .get(`api/Device/GetDevices/${orgId}`)
        .catch((err) => {
            return err.response.status;
        });

    return response;
}
export async function getDevicePrinters() {
    const response = await axios
        .get(`api/Device/Printers`)
        .catch((err) => {
            return err.response.status;
        });

    return response;
}
export async function getDevice(accountId) {
    const response = await axios
        .get(`api/Device/GetDevice/${accountId}`)
        .catch((err) => {
            return err.response.status;
        });

    return response;
}
export async function getDeviceSubscriptionDetails(deviceId, orgId) {
    const response = await axios
        .get(`api/Device/GetDeviceSubscriptionDetails/${deviceId}/${orgId}`)
        .catch((err) => {
            return err.response;
        });
    return response;
}
export async function searchSubOrganizations(organizationId, searchTerm) {
    let encodedSearchTerm = encodeURIComponent(searchTerm);
    const response = await axios
        .get(`api/Organization/${organizationId}/SearchSubOrganizations?searchTerm=${encodedSearchTerm}`)
        .catch((err) => {
            return err.response;
        });
    return response;
}
export async function searchUsers(organizationId, searchTerm) {
    let encodedSearchTerm = encodeURIComponent(searchTerm);
    const response = await axios
        .get(`api/Organization/${organizationId}/SearchUsers?searchTerm=${encodedSearchTerm}`)
        .catch((err) => {
            return err.response;
        });
    return response;
}
export async function searchDevices(organizationId, searchTerm) {
    let encodedSearchTerm = encodeURIComponent(searchTerm);
    const response = await axios
        .get(`api/Organization/${organizationId}/SearchDevices?searchTerm=${encodedSearchTerm}`)
        .catch((err) => {
            return err.response;
        });
    return response;
}

export async function getUserRoles() {
    const response = await axios
        .get(`api/Roles/GetRolesForUser`)
        .catch((err) => {
            return err.response;
        });
    return response;
}
export async function getUserDefaultOrg() {
    const response = await axios
        .get(`api/Organization/GetUserDefaultOrg`)
        .catch((err) => {
            return err.response;
        });
    return response;
}
export async function searchTopLevelOrganizations(searchTerm) {
    let encodedSearchTerm = encodeURIComponent(searchTerm);
    const response = await axios
        .get(`api/Organization/SearchTopLevelOrganizations?searchTerm=${encodedSearchTerm}`)
        .catch((err) => {
            return err.response;
        });
    return response;
}
export async function prepareSubscription(accountId, seats)
{
    let model = {
        accountId,
        seats
        }
    const response = await axios
        .post(`api/Payment/Prepare`, model)
        .catch((err) => {
            return err.response;
        });
    return response;
}
export async function getSubscription(accountId) {
    const response = await axios
        .get(`api/Payment/${accountId}/Subscriptions`)
        .catch((err) => {
            return err.response;
        });
    return response;
}

export async function getSubscriptionDetails(accountId) {
    const response = await axios
        .get(`api/Payment/${accountId}/SubscriptionDetails`)
        .catch((err) => {
            return err.response;
        });
    return response;
}

export async function getStructuralHierarchy(organizationId) {
    const response = await axios
        .get(`api/Organization/${organizationId}/structuralHierarchy`);
    return response?.data;
}

export async function insertStructuralHierarchySubOrg(hqId, parentId, name) {
    const model = {
        name,
        parentAccountId: parentId,
        location: name,
        Languages: [1],
        orgType: 2
    };
    const response = await axios
        .post(`api/Organization/${hqId}/suborganizations`, model);
    return response?.data;
}

export async function updateStructuralHierarchySubOrg(hqId, parentId, accountId,  name) {
    const model = {
        name,
        parentAccountId: parentId,
        Languages: [1]
    };
    const response = await axios
        .put(`api/Organization/${hqId}/suborganizations/${accountId}`, model);
    return response?.data;
}

export async function getSubscriptionManageLink(accountId) {
    const response = await axios
        .get(`api/Payment/${accountId}/Subscriptions/ManageLink`)
        .catch((err) => {
            return err.response;
        });
    return response;
}
export async function getSubscriptionUpdatePreview(accountId, seatCount) {
    let model = {
        accountId: accountId,
        seats: parseInt(seatCount)
    };
    const response = await axios
        .post(`api/Payment/${accountId}/Subscriptions/Preview`, model)
        .catch((err) => {
            return err.response;
        });
    return response;
}

export async function updateSubscription(accountId, seats, devices) {
    let model = {
        accountId,
        seats,
        devices
    }
    const response = await axios
        .post(`api/Payment/Prepare`, model)
        .catch((err) => {
            return err.response;
        });
    return response;
}

export async function importLocation(orgId, file) {

    try {
        const formData = new FormData();
        formData.append('file', file)
        const response = await axios
            .post(`api/ImportExport/${orgId}/ImportLocationData`, formData)
            .catch((err) => {
                return err.response;
            });
        return response;
    }
    catch (error) {
        console.log(error);
    }

}

export async function exportLocation(orgId) {

    try {
        const options = {
            url: `api/ImportExport/${orgId}/ExportLocationData`,
            method: 'get',
            responseType: 'blob'
        };

        const response = await axios(options)
            .catch((err) => {
                return err.response;
            });
        return response;
    }
    catch (error) {
        console.log(error);
    }

}

export async function setUpUser(model) {

    try {
        const response = await axios
            .post(`api/Onboarding/SetUpUser`, model)
            .catch((err) => {
                return err.response;
            });
        return response;
    }
    catch (error) {
        console.log(error);
    }

}

export async function validateExistingEmailAddress(emailAddress) {
    try {
        const response = await axios
            .get(`api/Onboarding/ValidateExistingEmailAddress`, {
                params: { emailAddress }
            })
            .catch((err) => {
                return err.response;
            });
        return response;
    }
    catch (error) {
        console.log(error);
    }
}

export async function getNavItems(orgId) {
    try {
        const response = await axios
            .get(`api/Navigation/GetNavigationItems/${orgId}`)
            .catch((err) => {
                return err.response;
            });
        return response;
    }
    catch (error) {
        console.log(error);
    }
}

export async function suppressLocationAddedModalForUser() {
    try {
        const response = await axios
            .post(`api/User/SuppressCreateLocationPopup`)
            .catch((err) => {
                return err.response;
            });
        return response;
    }
    catch (error) {
        console.log(error);
    }
}

export async function getUserPreferences() {
    const response = await axios
        .get(`api/User/Preferences`)
        .catch((err) => {
            return err.response;
        });
    return response;
}

export async function createSubscription(accountId, seats, cancelUrl) {
    let model = {
        accountId,
        seats,
        cancelUrl
    }
    const response = await axios
        .post(`api/Payment/Create`, model)
        .catch((err) => {
            return err.response;
        });
    return response;
}

export async function getTenantDetails(accountId) {
    const response = await axios
        .get(`api/Tenant/TenantDetails/${accountId}`)
        .catch((err) => {
            return err.response;
        });
    return response;
}

export async function updateTenantDetails(tenantModel) {
    const response = await axios
        .put(`api/Tenant/TenantDetails`, tenantModel);
    return response?.data;
}

export async function deleteSelected(accountIds) {
    const response = await axios
        .delete(`api/Organization/BulkDelete`, { data:accountIds});
    return response;
}

export async function updateLocation(parentId, id, location) {

    const response = await axios
        .put(`api/Organization/${parentId}/Locations/${id}`, location);
    return response?.data;
}

export async function bulkMoveAccounts(destinationAccountId, accounts){
    //make sure accountId is int
    const x = accounts.map((y) => ({...y, accountId: parseInt(y.accountId)}));

    const request = {
        destinationAccountId,
        accountNodes: x
    }

    const response = await axios.put(`api/Organization/BulkMove`, request);

    return response.data;
}

export async function getTenantUsers(accountId) {
    const response = await axios
        .get(`api/Tenant/${accountId}/Users`);
    return response?.data;
}

export async function processInvite(sharedCode) {

    const response = await axios
        .post(`api/invites/process?sharedCode=${encodeURIComponent(sharedCode)}`);
    return response;
}

export async function getAllTenantsUserIsUnder() {
    const response = await axios
        .get(`api/User/Tenants`);
    return response?.data;
}
export async function getTenantUserById(accountId, portalAccountId) {
    const response = await axios
        .get(`api/Tenant/${portalAccountId}/Users/${accountId}`);
    return response?.data;
}

export async function getTenantUserByEmail(portalAccountId, email) {
    const response = await axios
        .get(`api/Tenant/${portalAccountId}/Users/GetTenantUserByEmail/${email}`);
    return response?.data;
}

export async function createUser(portalAccountId, userAccountModel) {
    const response = await axios
        .post(`api/Tenant/${portalAccountId}/Users`, userAccountModel)
    return response?.data;
}
export async function updateTenantUser(portalAccountId, userAccountUpdateModel) {
    const response = await axios
        .put(`api/Tenant/${portalAccountId}/Users`, userAccountUpdateModel)
    return response?.data;
}
export async function resendInviteLink(orgId, userId) {
    const response = await axios
        .post(`api/User/${orgId}/ResendInvite/${userId}`)
    return response?.data;
}

export async function bulkDeleteUsers(tenantId, userAccountIds) {
    var request = {
        userAccountIds
    }

    try{
        const response = await axios.delete(`/api/Organization/${tenantId}/Users/Roles`, {data:request})

        return response.status === 200;
    }
    catch(e)
    {
        //404 just means no users were found. Just return false;
        if (e.status === 404){
            return false;
        }
        
        throw e;
    }
}
export async function getImportHistory(accountId, recordCount) {
    const response = await axios
        .get(`api/ImportExport/${accountId}/History?recordCount=10`);
    return response?.data;
}